












import {CHATKEEPER, EASYMODER} from "@/includes/constants";

import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class Main extends Vue {
    get homepageImage() {
      if (process.env.VUE_APP_TARGET_PROJECT === CHATKEEPER) {
        return require('../../assets/images/pages/keeper-home.png')
      } else if (process.env.VUE_APP_TARGET_PROJECT === EASYMODER) {
        return require('../../assets/images/pages/easymoder-home.png')
      }

      return require('../../assets/images/pages/piramis-home.png')
    }
}
